import React from 'react';
import {Box} from "@material-ui/core";

import {useBlockHeightObserver} from "../../../../../../utils/useBlockHeightObserver";

import TerminalsTrxTable from "../TerminalsTrxTable";
import DashboardData from "./components/DashboardData";

export default () => {

  const {ref, height} = useBlockHeightObserver();

  return (
    <>
      <div ref={ref}>
        <DashboardData />
      </div>
      <Box width="100%" height={`calc(100vh - ${250 + height}px)`} minHeight="500px" mt="3.9rem">
        <TerminalsTrxTable disableFilters />
      </Box>
    </>
  )
}
